import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { Theme } from '@mui/material';
import { styled } from '@mui/system';

const StyledToastContainer = styled(ToastContainer)(({ theme }) => {
  const theme_MUI = theme as unknown as Theme;

  return {
    '--toastify-z-index': theme_MUI.zIndex.modal - 1,
    '--toastify-font-family': theme_MUI.typography.fontFamily,
    '--toastify-toast-width': 'max-content',
    '--toastify-toast-background': theme_MUI.palette.background.paper,
    '--toastify-text-color-light': theme_MUI.palette.text.primary,

    '.Toastify__toast': {
      minWidth: 320,
      borderRadius: theme_MUI.shape.borderRadius * 4,
      boxShadow: theme_MUI.shadows[4],
      padding: theme_MUI.spacing(1, 2),
    },
    '.Toastify__toast-body': {
      display: 'flex',
      alignItems: 'center',
    },
    '.Toastify__close-button': {
      color: theme_MUI.palette.text.secondary,
      opacity: 0.9,
    },
    '.Toastify__close-button:hover': {
      opacity: 1,
    },
  };
});

const CustomToastContainer: FC = () => {
  const location = useLocation();

  useEffect(() => toast.dismiss(), [location]);

  return (
    <StyledToastContainer
      position='bottom-center'
      autoClose={false}
      pauseOnFocusLoss={false}
      draggable={false}
      hideProgressBar
      closeButton={false}
    />
  );
};

export default CustomToastContainer;
